import type { IBracketStore, } from "@store/types";
import { produce } from 'immer';
import type { StateCreator, } from "zustand";
import type { Store } from '../useStore';
import type{ ISettingsSlice, } from "./types";


export const createSettingsSlice: StateCreator<IBracketStore, [], [], ISettingsSlice> = ( set, get, ) => {


	const fetch = async () => {

		set(produce<Store>(state => {
			state.settings.fetching = true;
		}));

		await new Promise((resolve) => setTimeout(resolve, 1000));

		set(produce<Store>(state => {
			state.settings.ready = true;
			state.settings.fetching = false;
		}));

	}

	const reset = () => {
		set(produce<Store>(state => {
			state.settings.ready = false;
			state.settings.fetching = false;
		}));
	}

	const resetAsync = async () => {
		reset();
	}

	// place at the bottom of the call stack.
	setTimeout(_ => fetch(), 0);

	return {
		ready: false,
		fetching: false,
		fetch,
		reset,
		resetAsync,
	};

};
